






























































































































































import Vue from "vue";
import { mapMutations } from "vuex";
import { random } from "lodash";

import NumberTable from "@/components/NumberTable.vue";

/* eslint-disable  @typescript-eslint/no-explicit-any */
export default Vue.extend({
  name: "Home",
  components: {
    NumberTable,
  },
  data() {
    return {
      validating: false,
      numberToValidate: (null as unknown) as number,
      valid: false,
      warnValid: false,
      warnInvalid: false,
      validatedNumbers: Array<any>(),
      showSorted: false,
      sorted: "",
      emergencyMeeting: false,
      fired: false,
      resetAll: false,
      untie: false,
      sortUntie: 0,
      untieSorted: Array<number>(),
      random,
    };
  },
  created() {
    window.addEventListener("keyup", this.handleKeypress);
  },
  computed: {
    validNumbers(): Array<number> {
      return this.validatedNumbers
        .filter((item: any) => item.valid)
        .map((item: any) => item.num);
    },
    invalidNumbers(): Array<number> {
      return this.validatedNumbers
        .filter((item: any) => !item.valid)
        .map((item: any) => item.num);
    },
  },
  methods: {
    ...mapMutations(["addSorted", "reset"]),
    async doUntie() {
      let sorted = random(1, 75);
      const animateSort = () => {
        return new Promise((resolve) => {
          let animateCount = 15;
          const interval = setInterval(() => {
            this.sortUntie = random(1, 75);
            animateCount--;
            if (animateCount == 0) {
              clearInterval(interval)
              resolve(true);
            }
          }, 100);         
        });
      };
      await animateSort();

      while (this.untieSorted.includes(sorted)) {
        sorted = random(1, 75);
        this.sortUntie = sorted;
      }
      this.untieSorted.push(sorted);
      this.sortUntie = sorted;
    },
    closeUntie() {
      this.untieSorted = new Array<number>();
      this.sortUntie = 0;
      this.untie = false;
    },
    confirmReset() {
      this.reset();
      this.resetAll = false;
    },
    handleKeypress(e: KeyboardEvent) {
      if (e.code === "Space" && !this.validating) {
        this.sort();
      }

      if (e.code === "Escape" && this.validating) {
        this.closeValidation();
      }

      if (e.code === "KeyR") {
        this.resetAll = true;
      }

      if (e.code === "KeyV") {
        this.openValidation();
      }
    },
    sort() {
      window.removeEventListener("keyup", this.handleKeypress, false);
      let num: number;
      do {
        num = random(1, 75);
      } while (
        this.$store.state.sorted.includes(num) &&
        this.$store.state.sorted.length < 75
      );
      this.showSorted = true;
      this.sorted = this.getSortedLabel(num);
      setTimeout(() => {
        this.showSorted = false;
        window.addEventListener("keyup", this.handleKeypress);
      }, 2000);
      this.addSorted(num);
    },
    getSortedLabel(sorted: number) {
      if (sorted < 16) {
        return `B${sorted}`;
      }
      if (sorted > 15 && sorted < 31) {
        return `I${sorted}`;
      }
      if (sorted > 30 && sorted < 46) {
        return `N${sorted}`;
      }
      if (sorted > 45 && sorted < 61) {
        return `G${sorted}`;
      }
      if (sorted > 60) {
        return `O${sorted}`;
      }
      return "";
    },
    validate() {
      this.valid = this.$store.state.sorted.includes(this.numberToValidate);
      this.validatedNumbers.push({
        num: this.numberToValidate as number,
        valid: this.valid,
      });
      if (this.valid) {
        this.warnValid = true;
        setTimeout(() => {
          this.warnValid = false;
        }, 2000);
      } else {
        this.warnInvalid = true;
        setTimeout(() => {
          this.warnInvalid = false;
        }, 2000);
      }
      this.numberToValidate = (null as unknown) as number;
    },
    openValidation() {
      this.emergencyMeeting = true;
      setTimeout(() => {
        this.emergencyMeeting = false;
        this.validating = true;
      }, 3000);
    },
    closeValidation() {
      this.validating = false;
      this.validatedNumbers = Array<any>();
    },
    undoValidate() {
      this.validatedNumbers.pop();
    },
  },
});
